import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useStateContext } from "../../global-context/useGlobalContext";

const WhySection = () => {
  const { language } = useStateContext();

  return (
    <WhyWrapper>
      <LeftSpace></LeftSpace>
      <WhyText>
        <h1>
          {language ? <span>Pourquoi </span> : <span>Why </span>}
          {language ? "nous le faisons?" : "we do it?"}
        </h1>
        {language ? (
          <p>
            « Nous pensons que les dernières années ont été difficiles pour les
            petites et moyennes entreprises. Celles-ci représentent le cœur de
            notre société, de notre quotidien et il est primordial de les voir
            prospérer. Nous avons nous même travaillé au sein de nombreuses
            compagnies, créer la nôtre et connaissons bien la réalité, ainsi que
            les difficultés auxquelles nous faisons face. Contribuer en partie à
            votre succès et vous aider à vous développer serait pour nous la
            plus grande des satisfactions. » <br />
            <br />
            Marine et Robert
          </p>
        ) : (
          <p>
            "I think the last couple years were very difficult for small and
            medium sized businesses. They represent the heart of our society and
            daily life so it’s essential to see them thrive. We’ve worked within
            several businesses and created our own, so we're well aware of the
            hardships we can face. Contributing in small part to your success
            and helping you develop your business would mean a lot to us."
            <br />
            <br />
            Marine and Robert{" "}
          </p>
        )}
      </WhyText>
    </WhyWrapper>
  );
};

export default WhySection;

const WhyWrapper = styled(motion.div)`
  flex: 1;
  width: 100vw;
  height: 100vh;
  padding: 0 10vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: white;
  h1 {
    font-size: 3rem;
  }
  p {
    font-size: 1.5rem;
    padding-top: 4rem;
    line-height: 150%;
    font-style: italic;
  }
  @media (max-width: 650px) {
    padding: 10rem 2.5rem;
    height: fit-content;
  }
`;
const WhyText = styled.div`
  flex: 1;
  @media (max-width: 950px) {
    flex: 2;
  }
`;

const LeftSpace = styled.div`
  flex: 1;
  @media (max-width: 950px) {
    flex: 0;
  }
`;
